import React from 'react';
import styled from 'styled-components';

const Settings = () => {
  return (
    <settingLayer>

         <h2> Page Not Found</h2>

    </settingLayer>
  );
}

export default Settings;


const settingLayer = styled.div`
   display:flex;
   align-items:center;
   justify-content:center;
   top:50%;
   left:50%;
   font-size:2rem;

`;
